import { ReactNode, CSSProperties } from 'react'

interface Props {
  children: ReactNode
  className?: string
  style?: CSSProperties
}

const BookingFormLabel = ({ children, className = 'text-blue-iris', style }: Props): React.ReactElement => {
  return (
    <h3 className={`text-md font-medium mb-3 ${className}`} style={style}>
      {children}
    </h3>
  )
}

export default BookingFormLabel
